import { Tooltip } from 'antd'
import { FC } from 'react'
import ShipmentCalculatedValue from '../../../../../components/shipment-calculated-value/shipment-calculated-value'
import formatDuration from '../../../../../helpers/date-time/format-duration'
import {
    getShipmentDisplayCalculated,
    isShipmentCalculatedOnActual,
} from '../../../../../helpers/entities/shipment/get-shipment-display-calculated'
import PrintQueueEntry from '../../../../../types/api/print-queue-entry'
import {
    getPrintQueueEntryDurationMinutes,
    isQueueEntryFinishingTime,
} from '../../helpers/build-print-queue-end-times'

interface QueueCirculationTimeCellProps {
    record: PrintQueueEntry
}

const QueueCirculationTimeCell: FC<QueueCirculationTimeCellProps> = ({ record }) => {
    const shipment = record.print_job?.shipment
    const minutes = getPrintQueueEntryDurationMinutes(record)
    const label = isQueueEntryFinishingTime(record) ? 'Время отделки' : 'Время печати'
    const commonTime = getShipmentDisplayCalculated(shipment)?.commonTime ?? 0

    return (
        <ShipmentCalculatedValue isActual={isShipmentCalculatedOnActual(shipment)}>
            <Tooltip title={`${label} — ${formatDuration(minutes)}`}>
                <span>{formatDuration(commonTime)}</span>
            </Tooltip>
        </ShipmentCalculatedValue>
    )
}

export default QueueCirculationTimeCell
